<template>
  <div id="app-center">
    <my-head></my-head>
    <center-head></center-head>
    <div class="center-box">
      <div class="center-list">
        <el-row :gutter="30">
          <el-col :span="4">
            <left-menu></left-menu>
          </el-col>

          <el-col :span="20">
            <div class="center-left">
              <el-card>
                <el-input
                  v-model="search.project_name"
                  placeholder="请输入项目名称"
                  size="small"
                  :clearable="true"
                  style="width: 200px"
                ></el-input>
                <el-button
                  type="primary"
                  size="small"
                  icon="el-icon-search"
                  @click="$refs.tables.handleSearch()"
                  >搜索</el-button
                >
              </el-card>

              <WtDataTable
                ref="tables"
                :search="search"
                :listUrl="$db.config.getConfirmPayList"
              >
                <template slot="columns">
                  <el-table-column
                    label="项目名称"
                    prop="project_name"
                    align="center"
                    min-width="150"
                  >
                    <template slot-scope="scope">
                      <router-link
                        :to="
                          '/hospitalComProjectInfo?id=' + scope.row.project_id
                        "
                        >{{ scope.row.project_name }}</router-link
                      >
                      <div style="color: #666">
                        {{ scope.row.regdate_start }}至{{
                          scope.row.regdate_end
                        }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="立项类型" align="center" width="150">
                    省
                    <template slot-scope="scope">
                      <span>{{ scope.row.project_before_type_text }}</span>
                    </template>
                  </el-table-column>

                  <el-table-column
                    align="center"
                    label="计划结算金额"
                    prop="plan_money"
                    min-width="120"
                  >
                    <template slot-scope="scope">{{
                      scope.row.plan_money | setNumFormat
                    }}</template>
                  </el-table-column>

                  <el-table-column
                    align="center"
                    label="结算日期"
                    prop="plan_time"
                    min-width="100"
                  >
                    <template slot-scope="scope">
                      <!-- <span
                        v-if="(strToTime(scope.row.plan_time) <= Date.parse(new Date())) && scope.row.hospital_payment_status == 2"
                        style="color:#f56c6c"
                      >{{scope.row.plan_time}}（已逾期）</span>
                      <span
                        v-else-if="(strToTime(scope.row.plan_time,-1) <= Date.parse(new Date())) && scope.row.hospital_payment_status == 2"
                        style="color:#e6a23c"
                      >{{scope.row.plan_time}}</span> -->
                      <span>{{ scope.row.plan_time }}</span>
                    </template>
                  </el-table-column>

                  <el-table-column
                    prop="status_text"
                    label="状态"
                    width="100"
                    align="center"
                  >
                  </el-table-column>

                  <el-table-column
                    align="center"
                    label="结算状态"
                    prop="hospital_payment_status_text"
                    min-width="100"
                  ></el-table-column>

                  <el-table-column
                    prop="funds_audit_status_text"
                    label="审核状态"
                    width="100"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <span
                        v-if="scope.row.funds_audit_status == 2"
                        style="
                          color: red;
                          text-decoration: underline;
                          cursor: pointer;
                        "
                      >
                        <el-popover
                          placement="top"
                          title="审核意见："
                          width="200"
                          trigger="click"
                          :content="scope.row.audit_opinion"
                        >
                          <span slot="reference">{{
                            scope.row.funds_audit_status_text
                          }}</span>
                        </el-popover>
                      </span>
                      <span v-else>{{
                        scope.row.funds_audit_status_text
                      }}</span>
                    </template>
                  </el-table-column>

                  <el-table-column align="center" label="操作" min-width="150">
                    <template slot-scope="scope">
                      <el-button-group>
                        <el-button
                          type="primary"
                          size="mini"
                          icon="el-icon-circle-check"
                          v-if="scope.row.flow_id > 0"
                          :disabled="!scope.row.if_option"
                          @click="editModal(scope.row)"
                          >编辑结算</el-button
                        >
                        <el-button
                          type="primary"
                          size="mini"
                          icon="el-icon-circle-check"
                          :disabled="
                            scope.row.foundation_receipts_status == 1
                              ? true
                              : false
                          "
                          v-else
                          @click="openPayModal(scope.row)"
                          >结算</el-button
                        >
                      </el-button-group>
                    </template>
                  </el-table-column>
                </template>
              </WtDataTable>

              <el-dialog
                :visible.sync="payModal"
                title="上传结算凭证"
                center
                width="40%"
              >
                <el-dialog :visible.sync="img_show" append-to-body>
                  <img width="100%" :src="img_url" alt />
                </el-dialog>

                <el-form
                  :model="payForm"
                  ref="payFormRef"
                  label-width="100px"
                  :rules="rules"
                  class="demo-ruleForm"
                  style="width: 96%"
                >
                  <el-form-item label="金额" prop="allocation_money">
                    <!-- <el-input-number v-model="payForm.allocation_money" style="width:45%;text-align:left" :controls="false" :precision="2" :max="payInfo.max" :min="payInfo.min"></el-input-number> -->
                    <el-input
                      v-model.number="payForm.allocation_money"
                      placeholder="请输入金额"
                      style="width: 85%"
                      maxlength="9"
                    ></el-input>
                  </el-form-item>

                  <el-form-item label="结算时间" prop="allocation_time">
                    <el-date-picker
                      style="width: 85%"
                      v-model="payForm.allocation_time"
                      type="date"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      placeholder="选择日期"
                    ></el-date-picker>
                  </el-form-item>

                  <el-form-item label="财务姓名" prop="finance_user">
                    <el-input
                      v-model="payForm.finance_user"
                      placeholder="请输入财务姓名"
                      style="width: 85%"
                    ></el-input>
                  </el-form-item>

                  <el-form-item label="财务手机" prop="finance_phone">
                    <el-input
                      v-model="payForm.finance_phone"
                      placeholder="请输入财务手机号"
                      style="width: 85%"
                    ></el-input>
                  </el-form-item>

                  <el-form-item label="结算凭证" required>
                    <el-upload
                      ref="imgUploads"
                      :action="uploadImgUrl"
                      list-type="picture-card"
                      :on-preview="showImg"
                      :data="uploadParms"
                      :file-list="defImg"
                      name="img"
                      :before-upload="beforeUpload"
                      :on-success="
                        (response, file, fileList) => {
                          handlerUpload(fileList, 'defImg');
                        }
                      "
                      :on-remove="
                        (file, fileList) => {
                          handlerUpload(fileList, 'defImg');
                        }
                      "
                    >
                      <i class="el-icon-plus"></i>
                    </el-upload>
                  </el-form-item>

                  <el-form-item label="备注信息">
                    <el-input
                      type="textarea"
                      :autosize="{ minRows: 2, maxRows: 4 }"
                      placeholder="请输入结算备注内容"
                      v-model="payForm.allocation_remark"
                    ></el-input>
                  </el-form-item>
                </el-form>

                <span slot="footer">
                  <el-button
                    type="danger"
                    size="small"
                    icon="el-icon-close"
                    @click="cancelBtn"
                    >关闭</el-button
                  >
                  <el-button
                    type="primary"
                    size="small"
                    icon="el-icon-check"
                    @click="submitBtn"
                    :loading="loading"
                    >提交</el-button
                  >
                </span>
              </el-dialog>
            </div>
          </el-col>
        </el-row>
        <!-- Form -->
      </div>

      <foot-div></foot-div>
    </div>
  </div>
</template>
<script>
import baseUrl from "@/config/index";
import myHead from "../../public/head";
import centerHead from "../../public/center_head";
import leftMenu from "../../public/menu";
import footDiv from "../../public/foot";
export default {
  components: {
    myHead,
    centerHead,
    leftMenu,
    footDiv,
  },
  data() {
    var checkPhone = (rule, value, callback) => {
      let mobile = /^[1][0-9]{10}$/;
      if (!mobile.test(value)) {
        return callback(new Error("手机号码格式不正确！"));
      } else {
        return callback();
      }
    };

    var checkMoney = (rule, value, callback) => {
      if (parseFloat(this.payForm.allocation_money) > 0) {
        if (
          parseInt(this.payInfo.min) <=
            parseFloat(this.payForm.allocation_money) &&
          parseFloat(this.payForm.allocation_money) <=
            parseInt(this.payInfo.max)
        ) {
          return callback();
        } else {
          return callback(
            new Error(
              "结算金额必须在" +
                this.payInfo.min +
                "~" +
                this.payInfo.max +
                "之间！"
            )
          );
        }
      } else {
        return callback(new Error("请输入结算金额！"));
      }
    };

    return {
      search: {},

      loading: false,
      defImg: [],

      payInfo: [], //检测结算信息
      payModal: false, //上传结算凭证modal

      payForm: {
        id: null,
        allocation_money: null,
        allocation_time: null,
        finance_user: null,
        finance_phone: null,
        allocation_pic: [],
        allocation_pic_path: [],
      }, //上传结算凭证数据

      payImgArr: [], //结算凭证图片集
      defImgs: [], //编辑详情中默认图片

      rules: {
        allocation_money: [
          { required: true, message: "请输入结算金额！", trigger: "blur" },
          { validator: checkMoney },
        ],
        finance_user: [
          { required: true, message: "请输入财务姓名！", trigger: "blur" },
        ],
        finance_phone: [
          { required: true, message: "请输入财务电话", trigger: "blur" },
          { validator: checkPhone, trigger: "blur" },
        ],
        allocation_time: [
          { required: true, message: "请输入结算时间！", trigger: "change" },
        ],
      },

      uploadImgUrl: "", //上传图片接口url
      img_url: "", //图片预览路径
      img_show: false, //图片预览弹窗
      uploadParms: { file_type: 2 }, //图片上传所需参数
      flow_id: null, //编辑结算id
    };
  },
  methods: {
    //字符串转时间戳 用于比较
    strToTime(str, day = 0) {
      let time;
      // 转换日期格式
      str = str.replace(/-/g, "/"); // "2010/08/01";
      // 创建日期对象
      var date = new Date(str);
      // 加一天 不加
      time = date.setDate(date.getDate() + 1 + day);

      return time;
    },

    handlerUpload(fileList, name) {
      this.$set(this, name, []);
      this.$set(this, name, fileList);
    },

    //编辑结算框
    editModal(row) {
      this.getEditInfo(row.flow_id);
      this.flow_id = row.flow_id;
      this.openPayModal(row);
    },

    //打开结算modal
    openPayModal(row) {
      this.payForm.plan_id = row.id;
      this.payForm.approval_id = row.approval_id;
      this.payForm.allocation_money = Number(row.plan_money);
      this.payForm.allocation_time = this.getCurrentTime();
      let info = JSON.parse(sessionStorage.getItem("unitAuth"));
      this.payForm.finance_user = info.user_name;
      this.payForm.finance_phone = info.phone;
      //检测是否能够结算并返回限制金额
      this.$db
        .post(this.$db.config.checkPayFundsInfo, {
          approval_id: row.approval_id,
          plan_id: row.id,
        })
        .then((res) => {
          if (res && res.code == 200) {
            this.payInfo.min = Number(res.data.min);
            this.payInfo.max = Number(res.data.max);
            this.payModal = true;
          }
        });
    },

    // 取消结算弹框
    cancelBtn() {
      //弹框关闭调用
      this.payModal = false;
      this.$refs["imgUploads"].clearFiles(); //清空图片
      this.$refs["payFormRef"].resetFields();
      this.flow_id = null;
    },

    beforeUpload(file) {
      let bool = this.$fnc.checkUploadImg(file);
      return bool;
    },

    //预览图片
    showImg(file) {
      this.img_url = file.url;
      this.img_show = true;
    },

    // onSuccess(response, file, fileList) {
    //   //图片赋值
    //   let imgArr = [];
    //   for (const key in fileList) {
    //     if (fileList[key].hasOwnProperty("response")) {
    //       imgArr.push(fileList[key].response.data.id);
    //     } else {
    //       imgArr.push(fileList[key].id);
    //     }
    //     this.payImgArr = imgArr;
    //   }
    // },

    // delPic(file, fileList) {
    //   //图片赋值
    //   let imgArr = [];
    //   for (const key in fileList) {
    //     if (fileList[key].hasOwnProperty("response")) {
    //       imgArr.push(fileList[key].response.data.id);
    //     } else {
    //       imgArr.push(fileList[key].id);
    //     }
    //     this.payImgArr = imgArr;
    //   }
    // },

    //获取编辑数据
    getEditInfo(id) {
      this.$db
        .post(this.$db.config.getPayFundsDetail, { id: id })
        .then((res) => {
          if (res.code == 200) {
            this.payForm = res.data;
            this.defImg = res.data.allocation_pic_path;
          }
        });
    },

    //提交结算凭证操作
    submitBtn() {
      let url;

      if (this.defImg && this.defImg.length > 0) {
        let arr = [];

        this.defImg.forEach((item, index) => {
          if (item.hasOwnProperty("response")) {
            arr.push(item.response.data.id);
          } else {
            arr.push(item.id);
          }
        });
        this.payForm.allocation_pic = arr;
      } else {
        return this.$message.warning("请上传结算凭证！");
      }

      this.loading = true;

      this.$refs["payFormRef"].validate((valid) => {
        if (valid) {
          if (this.flow_id > 0) {
            this.payForm.id = this.flow_id;
            url = this.$db.config.editPayFundsInfo;
          } else {
            url = this.$db.config.addPayFundsInfo;
          }

          this.$db.post(url, this.payForm).then((res) => {
            this.loading = false;
            if (res && res.code == 200) {
              this.$message.success(res.msg);
              this.cancelBtn();
              this.$refs.tables.reloadData();
            }
          });
        } else {
          this.loading = false;
          this.$message.warning("请填写完整信息！");
        }
      });
    },

    /**
     * 获取当前时间
     * @param  {Number} type [1:Y-m-d 2:Y-m-d H 3:Y-m-d H:i 4:Y-m-d H:i:s]
     * @return {[type]}      [description]
     */
    getCurrentTime(type = 1) {
      var date = new Date();
      var seperator1 = "-";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      var hour = date.getHours();
      var minute = date.getMinutes();
      var second = date.getSeconds();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      if (hour >= 1 && hour <= 9) {
        hour = "0" + hour;
      }
      if (minute >= 1 && minute <= 9) {
        minute = "0" + minute;
      }
      if (second >= 1 && second <= 9) {
        second = "0" + second;
      }
      let current = year + seperator1 + month + seperator1 + strDate;
      switch (type) {
        case 1:
          break;
        case 2:
          current = current + " " + hour;
          break;
        case 3:
          current = current + " " + hour + ":" + minute;
          break;
        case 4:
          current = current + " " + hour + ":" + minute + ":" + second;
          break;
      }
      return current;
    },
  },
  created() {
    this.uploadImgUrl = baseUrl + this.$db.config.uploadImgUrl;
  },
};
</script>
<style lang="scss" scoped>
#app-center {
  width: 100%;
  // height: 100%;
  background-color: #f1f1f1;
}
.center-box {
  .center-list {
    //max-width: 1200px;
    margin: 0 auto;
    width: 98%;
    padding-top: 20px;
    .center-left {
      background-color: #fff;
      border-top: 2px solid #b60205;
      padding-top: 30px;
      overflow: hidden;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Hospital/comproject/payment/list.vue